module.exports = __webpack_public_path__ + "img/add_to_cart.9927baf7.svg";